<template>

    <AjanlatBase :titleExtra="titleExtra"
                 v-if="kobetirVisible() || ajanlKobetagVisible() || parhuzamosVisible() || polgarorVisible()">

        <v-form slot="biztositoi-adatok" ref="ajanlat-adatok">

            <v-layout row wrap>

                <BnFormField v-if="kobetirVisible()" :attributes="adatok.kobetir_egyesuleti"/>

                <BnFormField v-if="ajanlKobetagVisible()" :attributes="adatok.ajanl_kobetagsag"/>

                <BnFormField v-if="parhuzamosVisible()" :attributes="adatok.kobe_parhuzamos_kotvenyszam"/>

                <BnFormField v-if="polgarorVisible()" :attributes="adatok.kobe_polgaror_igazsz"/>

            </v-layout>

        </v-form>

    </AjanlatBase>

</template>

<script>
import { listTypes } from '../../../../../../../../modules/List';
import BnFormField from '../../../../../../../basecomponents/BnFormField.vue';
import AjanlatBase from '../KGFBAjanlatBase.vue';
import offerData from '../../../../../mixins/ajanlatiadatok/biztosito_specifikus/OfferData';

export default {
    components: {
        AjanlatBase,
        BnFormField,
    },
    mixins: [offerData],
    mounted() {
        this.kobetirChange();
    },
    methods: {
        kobetirVisible() {
            return true;
        },
        ajanlKobetagVisible() {
            return this.kobetirEgyesulet === true;
        },
        parhuzamosVisible() {
            return this.$store.getters.tarifaData.belepnyil === 3
                && this.$store.getters.tarifaData.elozobiztosito === 6;
        },
        polgarorVisible() {
            return this.$store.getters.tarifaData.polgaror === true;
        },
        kobetirChange() {
            this.kobetirEgyesulet = this.$store.getters.tarifaData.kobetir_egyesuleti;
        },
    },
    data() {
        return {
            name: 'AjanlatAdatokB15_V0',
            kobetirEgyesulet: false,
            adatok: {
                kobetir_egyesuleti: {
                    type: 'select',
                    label: 'Ön KÖBE egyesületi tag?',
                    visible: true,
                    editable: true,
                    help: true,
                    mezo: 'kobetir_egyesuleti',
                    path: 'tarifaData.kobetir_egyesuleti',
                    itemsText: 'key',
                    itemsValue: 'value',
                    resource: listTypes.yesno,
                    change: this.kobetirChange,
                },
                ajanl_kobetagsag: {
                    type: 'text',
                    label: 'KÖBE-nél lévő biztosítás kötvényszáma',
                    visible: true,
                    editable: true,
                    help: true,
                    mezo: 'ajanl_kobetagsag',
                    path: 'tarifaData.ajanl_kobetagsag',
                },
                kobe_parhuzamos_kotvenyszam: {
                    type: 'text',
                    label: 'KÖBE párhuzamos szerződés kötvényszáma',
                    visible: true,
                    editable: true,
                    help: true,
                    mezo: 'kobe_parhuzamos_kotvenyszam',
                    path: 'tarifaData.kobe_parhuzamos_kotvenyszam',
                },
                kobe_polgaror_igazsz: {
                    type: 'text',
                    label: 'Polgárőr tagsági/igazolvány szám',
                    visible: true,
                    editable: true,
                    help: true,
                    mezo: 'kobe_polgaror_igazsz',
                    path: 'tarifaData.kobe_polgaror_igazsz',
                },
            },
        };
    },
};
</script>
